import React from "react";
import { isEmpty } from "lodash";
import { makeStyles } from "@material-ui/core";
import { SpinnerOverlay, MarkHighlighter } from "@components";

type Props = {
  search: string | string[];
  commentBox: React.ReactNode;
  loading?: boolean;
  list: React.ReactNode;
  style?: React.CSSProperties;
};

export function EventLogLayout(props: Props) {
  const { commentBox, loading, list } = props;
  const classes = useStyles({});

  const listRef = React.useRef<HTMLDivElement>(null);

  return (
    <div id="contact_event_log" className={classes.root} style={props.style}>
      {!isEmpty(props.search) && (
        <MarkHighlighter
          highlightSearch={props.search}
          getMarkjsContext={() => listRef.current}
        />
      )}

      <div className={classes.form}>{commentBox}</div>

      <div className={classes.body}>
        <SpinnerOverlay show={loading} />
        {list}
      </div>
    </div>
  );
}

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column"
  },
  form: { flex: 0, margin: 16 },
  body: { flex: 1, overflow: "hidden", position: "relative" }
});
